/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */

import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import axios from 'axios';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import AnuidadeService from '../services/AnuidadeService';
import BuscarDadosCobrancaDTO from '../dtos/BuscarDadosCobrancaDTO';
import CobrancaDTO from '../dtos/CobrancaDTO';
import CobrancaParcelaDTO from '../dtos/CobrancaParcelaDTO';
import DebitoDTO from '../dtos/DebitoDTO';
import GerarBoletoDTO from '../dtos/GerarBoletoDTO';
import GerarCobrancaDTO from '../dtos/GerarCobrancaDTO';
import Loading from '../components/Loading';
import { ModalEnviarPorEmail } from '../components/ModalEnviarPorEmail';
import { ModalPagamentoCartao } from '../components/ModalPagamentoCartao';
import PagamentoAnuidadeInscritoDTO from '../dtos/PagamentoAnuidadeInscritoDTO';
import PagamentoRealizadoDTO from '../dtos/PagamentoRealizadoDTO';
import ResultCarregaDebito from '../dtos/cobol/ResultCarregaDebito';
import ResultMontarCobranca from '../dtos/cobol/ResultMontarCobranca';
import ResultPreparaBoleto from '../dtos/cobol/ResultPreparaBoleto';
import ResultTiposDebitos from '../dtos/cobol/ResultTiposDebitos';

const ANUIDADE_CORRENTE = 2026;
const ANUIDADE_ANTERIOR = 2025;

interface FieldProps {
  init: number;
  end: number;
  type: 'int' | 'number';
}

const ANO_INICIO_DEB_FIELD: FieldProps = { init: 0, end: 4, type: 'int' };
const ANO_FIM_DEB_FIELD: FieldProps = { init: 4, end: 8, type: 'int' };
const COTA_INICIO_DEB_FIELD: FieldProps = { init: 8, end: 10, type: 'int' };
const COTA_FIM_DEB_FIELD: FieldProps = { init: 10, end: 12, type: 'int' };
const TOTAL_COTAS_DEB_FIELD: FieldProps = { init: 12, end: 14, type: 'int' };
const NRO_AVOS_DEB_FIELD: FieldProps = { init: 14, end: 16, type: 'int' };
const COD_LANC_DEB_FIELD: FieldProps = { init: 16, end: 19, type: 'int' };
const VALOR_ANUID_DEB_FIELD: FieldProps = { init: 19, end: 26, type: 'number' };
const VALOR_MULTA_DEB_FIELD: FieldProps = { init: 26, end: 33, type: 'number' };
const VALOR_JUROS_DEB_FIELD: FieldProps = { init: 33, end: 40, type: 'number' };
const VALOR_TOTAL_DEB_FIELD: FieldProps = { init: 40, end: 47, type: 'number' };
const DTA_VENC_DEB_FIELD: FieldProps = { init: 47, end: 55, type: 'int' };
const FLAG_BLOQUEIO_COTA_DEB_FIELD: FieldProps = {
  init: 55,
  end: 56,
  type: 'int',
};

const MENSAGEM_ERRO_BASE = 'Houve um problema no sistema. Por favor, entre em contato com a nossa central de atendimento, através dos telefones (021) 2730-6525 ou (021) 2272-6150 e informe o código ';

interface ValidarAnuidadeProps {
  numeroInscricao: number;
  cpf: string;
  numeroSeguranca: number;
}

interface MensagemAlerta {
  show: boolean;
  mensagem: string;
}
interface TipoDebitoProps {
  CodigoTipo: number;
  DescricaoTipo: string;
}
interface AnuidadeProps {
  pesquisarComoTratarUniao: string;
  tipoDebito: TipoDebitoProps;
  debitoResult?: ResultCarregaDebito;
  pagamentoAnuidadeInscrito: PagamentoAnuidadeInscritoDTO;
}

interface PagamentoForm {
  formaPagamento: 'B' | 'C' | 'R' | null;
  tipoSelecao: 'T' | 'V' | 'S';
  parcelaSelecionada?: CobrancaParcelaDTO;
}
interface PagamentoProps {
  cobranca: CobrancaDTO;
  debitosAgrupados: DebitoDTO[];
  qntAvos: number;
  emitirSeparado: boolean;
  pagamento: PagamentoForm;
}

interface AnuidadeContextData {
  anoAnuidade: number;
  tipoPagamentoRecorrente: boolean;
  anuidade: AnuidadeProps;
  mensagemAlerta: MensagemAlerta;
  selecaoDebitosMode: SelecaoDebitosModeProps;
  pagamento: PagamentoProps;
  validarAnuidade: (validar: ValidarAnuidadeProps) => Promise<void>;
  validarDebito: () => Promise<void>;
  changeSelectedDebito: (debito: DebitoDTO) => void;
  onClickPagamentoTotal: () => Promise<void>;
  onClickPagamentoVencidos: () => Promise<void>;
  onClickPagamentoDebitosSelecionados: (
    gerarBoletoSeparadamente: boolean,
  ) => Promise<void>;
  changePagamento: (form: PagamentoForm) => void;

  goBoletoEnviarPorEmail: () => Promise<void>;
  goBoletoRealizarDownload: () => Promise<void>;
  goCartaoRealizarPagamento: () => Promise<void>;

  pagamentosRealizados: PagamentosRealizadosProps;

  showMensagemOutrasAnuidadesAreaRestrita: boolean;
}

export interface SelecaoDebitosModeProps {
  showBtnPagamentoTotal: boolean;
  showBtnPagamentoVencidos: boolean;
  showBtnSelecionarDebitos: boolean;
  showDebitos: boolean;
  selectDebitosEnabled: boolean;
  debitos: DebitoDTO[];
}

interface ModalPagamentoCartaoProps {
  show: boolean;
  urlCobrancaCartao: string;
}

interface AnuidadeProviderProps {
  children: ReactNode;
}

interface PagamentosRealizadosProps {
  nomeInscrito: string;
  numeroInscricao: number;
  pagamentos: PagamentoRealizadoDTO[];
}

const AnuidadeContext = createContext<AnuidadeContextData>(
  {} as AnuidadeContextData,
);

const getValueDebitoReg = (
  reg: string | undefined,
  field: FieldProps,
): number | string => {
  const value = reg!.substring(field.init, field.end);
  if (field.type === 'int') {
    return parseInt(value, 10);
  }
  if (field.type === 'number') {
    return parseFloat(value) / 100;
  }
  return value;
};

const makeCobranca = (data: ResultMontarCobranca): CobrancaDTO => {
  const parcelas: CobrancaParcelaDTO[] = [];

  const formasPagamento = data.FormasPagto.VetorFormas;
  formasPagamento.forEach((formaPagamento) => {
    const parcela = {
      id: uuidv4(),
      qntParcelas: formaPagamento.QtdParcelas,
      valorPrimeiraParcela: formaPagamento.ValorPrimParc,
      valorOutrasParcelas: formaPagamento.ValorOutrasParc,
      total: formaPagamento.ValorPrimParc,
    } as CobrancaParcelaDTO;
    if (parcela.qntParcelas > 1) {
      const valorParcelas = (parcela.qntParcelas - 1) * parcela.valorOutrasParcelas;
      parcela.total = parseFloat((parcela.total + valorParcelas).toFixed(2));
    }
    parcelas.push(parcela);
  });

  const result = {
    isAvista: !!data.MotivoAVista,
    valorDesconto: data.ValorDescontoAVista ? data.ValorDescontoAVista : 0,
    parcelas,
    original: data,
  };

  return result;
};

const makeDebitos = (
  debitosCodigo: {
    RegDebito?: string;
    RegistroAgrup?: string;
  }[],
  propRegistro: 'RegDebito' | 'RegistroAgrup',
) => {
  const result = debitosCodigo.map((debitoCodigo) => {
    const debitoReg = debitoCodigo[propRegistro];
    const debito = {
      id: uuidv4(),
      ano_inicio_deb: getValueDebitoReg(debitoReg, ANO_INICIO_DEB_FIELD),
      ano_fim_deb: getValueDebitoReg(debitoReg, ANO_FIM_DEB_FIELD),
      cota_inicio_deb: getValueDebitoReg(debitoReg, COTA_INICIO_DEB_FIELD),
      cota_fim_deb: getValueDebitoReg(debitoReg, COTA_FIM_DEB_FIELD),
      total_cotas_deb: getValueDebitoReg(debitoReg, TOTAL_COTAS_DEB_FIELD),
      nro_avos_deb: getValueDebitoReg(debitoReg, NRO_AVOS_DEB_FIELD),
      cod_lanc_deb: getValueDebitoReg(debitoReg, COD_LANC_DEB_FIELD),
      valor_anuid_deb: getValueDebitoReg(debitoReg, VALOR_ANUID_DEB_FIELD),
      valor_multa_deb: getValueDebitoReg(debitoReg, VALOR_MULTA_DEB_FIELD),
      valor_juros_deb: getValueDebitoReg(debitoReg, VALOR_JUROS_DEB_FIELD),
      valor_total_deb: getValueDebitoReg(debitoReg, VALOR_TOTAL_DEB_FIELD),
      dta_venc_deb: getValueDebitoReg(debitoReg, DTA_VENC_DEB_FIELD),
      flag_bloqueio_cota_deb: getValueDebitoReg(
        debitoReg,
        FLAG_BLOQUEIO_COTA_DEB_FIELD,
      ),
      selected: false,
    } as DebitoDTO;
    return debito;
  });

  return result;
};

const ajustarDataBoleto = (data: ResultPreparaBoleto): GerarBoletoDTO => {
  const result: any = {
    aceite: '',
    especieDoc: '',
    dataProcessamento: '',
    dataDocumento: '',
    banco: '',
    agencia: '',
    codBeneficiario: '',
    carteira: '',
    numDoc: '',
    nossoNumero: '',
    valor: '',
    vencimento: '',
    nomePagador: '',
    cpfCnpjPagador: '',
    cidadePagador: '',
    enderecoPagador: '',
    bairroPagador: '',
    estadoPagador: '',
    cepPagador: '',
    tipoPagamento: '',
    codPartilha01: '',
    valorPartilha01: '',
    codPartilha02: '',
    valorPartilha02: '',
    codPartilha03: '',
    valorPartilha03: '',
    tipoValor: '',
    pagamentoMinimo: '',
    pagamentoMaximo: '',
    infoAdicionais: '',
    mensagemLinha1: '',
    mensagemLinha2: '',
    mensagemLinha3: '',
    mensagemLinha4: '',
    mensagemLinha5: '',
    mensagemLinha6: '',
    mensagemLinha7: '',
    mensagemLinha8: '',
    mensagemLinha9: '',
    customContent: [],
  };

  function removeEspacoBancoInicio(value: string): string {
    let r = value;
    while (r.indexOf(' ') === 0) {
      r = r.replace(' ', '');
    }
    return r;
  }

  data.Linhas.VetorLinhas.forEach((linha) => {
    if (linha) {
      if (linha.indexOf('customContent') >= 0) {
        result.customContent = [];
      } else if (linha.indexOf('|text') >= 0) {
        const linhaAjust = `${linha} |nl:1|`;
        result.customContent.push(linhaAjust);
      } else {
        const indexDoisPontos = linha.indexOf(':');
        if (indexDoisPontos >= 0) {
          const propName = linha.substring(0, indexDoisPontos);
          let propValue = linha.substring(indexDoisPontos + 1);
          propValue = removeEspacoBancoInicio(propValue);
          result[propName] = propValue;
        }
      }
    }
  });

  return result as GerarBoletoDTO;
};

function AnuidadeProvider({ children }: AnuidadeProviderProps) {
  const history = useHistory();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [tipoPagamentoRecorrente, setTipoPagamentoRecorrente] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState<MensagemAlerta>({
    show: false,
    mensagem: '',
  });
  const [
    showMensagemOutrasAnuidadesAreaRestrita,
    setShowMensagemOutrasAnuidadesAreaRestrita,
  ] = useState<boolean>(false);
  const [selecaoDebitosMode, setSelecaoDebitosMode] = useState<SelecaoDebitosModeProps>({
  } as SelecaoDebitosModeProps);

  const [anoAnuidade, setAnoAnuidade] = useState(ANUIDADE_CORRENTE);
  const [anuidade, setAnuidade] = useState<AnuidadeProps>({} as AnuidadeProps);

  const [pagamento, setPagamento] = useState<PagamentoProps>(
    {} as PagamentoProps,
  );

  const [modalPagamentoCartao, setModalPagamentoCartao] = useState<ModalPagamentoCartaoProps>({
    show: false,
    urlCobrancaCartao: '',
  });

  const [showModalEnvioBoletoEmail, setShowModalEnvioBoletoEmail] = useState<boolean>(false);

  // eslint-disable-next-line max-len
  const [pagamentosRealizados, setPagamentosRealizados] = useState<PagamentosRealizadosProps>({} as PagamentosRealizadosProps);

  function changeSelectedDebito(debito: DebitoDTO) {
    const { debitos } = selecaoDebitosMode;

    const selected = !debito.selected;

    const validarParcelados = debito.total_cotas_deb > 0;

    const debitosUpdate = debitos.map((item) => {
      const itemDebito = { ...item };
      if (validarParcelados) {
        if (
          itemDebito.ano_inicio_deb === debito.ano_inicio_deb
          && itemDebito.ano_fim_deb === debito.ano_fim_deb
          && itemDebito.total_cotas_deb === debito.total_cotas_deb
        ) {
          if (itemDebito.cota_fim_deb <= debito.cota_fim_deb) {
            if (selected) {
              itemDebito.selected = selected;
            }
          } else if (itemDebito.cota_fim_deb > debito.cota_fim_deb) {
            itemDebito.selected = false;
          }
        }
      } else if (
        itemDebito.total_cotas_deb === 0
        && itemDebito.cod_lanc_deb === debito.cod_lanc_deb
      ) {
        if (itemDebito.ano_fim_deb <= debito.ano_fim_deb) {
          if (selected) {
            itemDebito.selected = selected;
          }
        } else if (itemDebito.ano_fim_deb > debito.ano_fim_deb) {
          itemDebito.selected = false;
        }
      }
      return itemDebito;
    });

    setSelecaoDebitosMode({
      ...selecaoDebitosMode,
      debitos: debitosUpdate,
    });
  }

  function tratarErroRetorno(codigoRetorno: number, chaveChamada: string) {
    if (codigoRetorno >= 1 && codigoRetorno <= 3) {
      let parametro = '';
      switch (codigoRetorno) {
        case 1:
          parametro = 'do endereço';
          break;
        case 2:
          parametro = 'do CPF';
          break;
        case 3:
          parametro = 'do CEP';
          break;
        default:
          parametro = '';
      }

      const mensagem = `Em função da desatualização ${parametro} no seu cadastro, não foi possível gerar o boleto bancário. Por favor, entre em contato com a nossa central de atendimento telefônico, através dos números (021)2730-6525 ou (021)2272-6150, para atualizar os seus dados.`;

      setMensagemAlerta({ show: true, mensagem });
    } else if (codigoRetorno >= 4 && codigoRetorno <= 8) {
      const mensagem = 'Não há débitos de anuidades em seu cadastro';
      setMensagemAlerta({ show: true, mensagem });
    } else if (codigoRetorno > 8) {
      // erro
      let messagemErro = `${MENSAGEM_ERRO_BASE}`;
      if (chaveChamada) {
        messagemErro += `${chaveChamada}-`;
      }
      messagemErro += codigoRetorno;
      toast.error(messagemErro);
    }
  }

  // return tiposDebitos.Dados.Vetor.find(
  //   (item) => item.CodigoTipo === 10
  //     || item.CodigoTipo === 11
  //     || item.CodigoTipo === 12
  //     || item.CodigoTipo === 13
  //     || item.CodigoTipo === 14,
  // );
  function getTipoDebitoAnuidadeCorrente(tiposDebitos: ResultTiposDebitos) {
    const year = new Date().getFullYear();
    if (year === ANUIDADE_CORRENTE) {
      if (anoAnuidade === ANUIDADE_CORRENTE) {
        return tiposDebitos.Dados.Vetor.find(
          (item) => item.CodigoTipo === 10
            || item.CodigoTipo === 11
            || item.CodigoTipo === 12
            || item.CodigoTipo === 13
            || item.CodigoTipo === 14,
        );
      }
    } else {
      if (anoAnuidade === ANUIDADE_CORRENTE) {
        return tiposDebitos.Dados.Vetor.find((item) => item.CodigoTipo === 901);
      }
      if (anoAnuidade === ANUIDADE_ANTERIOR) {
        return tiposDebitos.Dados.Vetor.find(
          (item) => item.CodigoTipo === 10
            || item.CodigoTipo === 11
            || item.CodigoTipo === 12
            || item.CodigoTipo === 13
            || item.CodigoTipo === 14,
        );
      }
    }
    return null;
  }

  function getTipoPagamentoRecorrente(
    tiposDebitos: ResultTiposDebitos,
  ): boolean {
    const year = new Date().getFullYear();
    if (year === ANUIDADE_CORRENTE) {
      if (anoAnuidade === ANUIDADE_CORRENTE) {
        const result = tiposDebitos.Dados.Vetor.find(
          (item) => item.CodigoTipo === 10,
        );
        return !!result;
      }
    } else if (anoAnuidade === ANUIDADE_CORRENTE) {
      const result = tiposDebitos.Dados.Vetor.find(
        (item) => item.CodigoTipo === 901,
      );
      return !!result;
    }
    return false;
  }

  async function validarAnuidade({
    numeroInscricao,
    cpf,
    numeroSeguranca,
  }: ValidarAnuidadeProps): Promise<void> {
    setLoading(true);
    setMensagemAlerta({ show: false, mensagem: '' });
    try {
      const result = await AnuidadeService.buscarDadosPagamentoAnuidade({
        numeroInscricao,
        cpf,
        numeroSeguranca,
        anuidade: anoAnuidade,
      });

      const { pagamentoAnuidadeInscrito } = result;
      if (pagamentoAnuidadeInscrito && pagamentoAnuidadeInscrito.numeroFicha) {
        const tiposDebitos = await AnuidadeService.tiposDebitos(
          pagamentoAnuidadeInscrito.numeroFicha,
        );
        if (tiposDebitos.Retorno === 0 || tiposDebitos.Retorno === 8) {
          const tipoDebitoAnuidadeCorrente = getTipoDebitoAnuidadeCorrente(tiposDebitos);
          if (tipoDebitoAnuidadeCorrente) {
            const tipoPagamentoRecorrenteResult = getTipoPagamentoRecorrente(tiposDebitos);
            setTipoPagamentoRecorrente(tipoPagamentoRecorrenteResult);
            const pesquisarComoTratarUniao = tiposDebitos.Dados.ComoTratarDebUnidos;
            setAnuidade({
              pesquisarComoTratarUniao,
              tipoDebito: tipoDebitoAnuidadeCorrente,
              pagamentoAnuidadeInscrito,
            });
            history.push('/debito');
          } else {
            const {
              pagamentoAnuidadeInscrito: { nomeInscrito, debitosPagos },
            } = await AnuidadeService.buscarPagamentosRealizados({
              numeroInscricao,
              cpf,
              numeroSeguranca,
              anuidade: anoAnuidade,
            });
            if (debitosPagos && debitosPagos.length) {
              setPagamentosRealizados({
                nomeInscrito,
                numeroInscricao,
                pagamentos: debitosPagos,
              });
              history.push('/pagamentos-realizados');
            } else {
              const mensagem = `Não há débitos de anuidade ${anoAnuidade} em seu cadastro`;
              setMensagemAlerta({ show: true, mensagem });
            }
          }
        } else {
          const codigoRetorno = tiposDebitos.Retorno;
          if (codigoRetorno >= 4 && codigoRetorno <= 8) {
            const {
              pagamentoAnuidadeInscrito: { nomeInscrito, debitosPagos },
            } = await AnuidadeService.buscarPagamentosRealizados({
              numeroInscricao,
              cpf,
              numeroSeguranca,
              anuidade: anoAnuidade,
            });
            if (debitosPagos && debitosPagos.length) {
              setPagamentosRealizados({
                nomeInscrito,
                numeroInscricao,
                pagamentos: debitosPagos,
              });
              history.push('/pagamentos-realizados');
            } else {
              tratarErroRetorno(codigoRetorno, 'IRA');
            }
          } else {
            tratarErroRetorno(codigoRetorno, 'IRA');
          }
        }
      } else {
        const mensagem = 'Verifique seus dados e tente novamente';
        setMensagemAlerta({ show: true, mensagem });
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        const { response } = e;
        if (response) {
          const { data } = response;
          toast.error(
            data.mensagemErro
              ? data.mensagemErro
              : 'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
          );
        }
      } else {
        toast.error(
          'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
        );
      }
    }
    setLoading(false);
  }

  async function buscarDadosCobranca(dadosCobranca: BuscarDadosCobrancaDTO) {
    setLoading(true);
    try {
      const montarCobrancaResult = await AnuidadeService.montarCobranca(
        dadosCobranca,
      );
      if (montarCobrancaResult.Retorno === 0) {
        const cobranca = makeCobranca(montarCobrancaResult);
        const debitosAgrupados = makeDebitos(
          montarCobrancaResult.DadosAgrupados.VetorAgrup,
          'RegistroAgrup',
        );
        let qntAvos = 0;
        if (debitosAgrupados.length === 1) {
          qntAvos = debitosAgrupados[0].nro_avos_deb;
        }

        const result = {
          cobranca,
          debitosAgrupados,
          qntAvos,
          emitirSeparado: dadosCobranca.emitirSeparado,
          pagamento: {
            formaPagamento: 'B',
            tipoSelecao: dadosCobranca.tipoSelecao,
            parcelaSelecionada:
              dadosCobranca.emitirSeparado && cobranca.parcelas.length > 0
                ? cobranca.parcelas[0]
                : undefined,
          },
        } as PagamentoProps;
        setPagamento(result);
        history.push('/pagamento');
      } else {
        tratarErroRetorno(montarCobrancaResult.Retorno, 'MC');
      }
    } catch (e) {
      toast.error(
        'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
      );
    }
    setLoading(false);
  }

  function getVetorDebitosSelecionados(debitos?: DebitoDTO[]) {
    const devitosValidacao = debitos || selecaoDebitosMode.debitos;
    let vetorDebitosSelecionados = '';
    devitosValidacao.forEach((debito) => {
      if (debito.selected) {
        vetorDebitosSelecionados += 'S';
      } else {
        vetorDebitosSelecionados += 'N';
      }
    });
    return vetorDebitosSelecionados;
  }

  async function onClickPagamentoTotal(
    debitoResult?: ResultCarregaDebito,
    debitos?: DebitoDTO[],
  ) {
    const debito = debitoResult || anuidade.debitoResult;
    if (debito) {
      const vetorDebitosSelecionados = getVetorDebitosSelecionados(debitos);
      await buscarDadosCobranca({
        numeroFicha: debito.Ficha,
        codigoTipoDebito: debito.CodTipDeb,
        tipoSelecao: 'T',
        emitirSeparado: false,
        qntDebitoTotal: debito.QtdDebTotal,
        valorTotal: debito.ValDebTotal,
        qntDebitoBloqueado: debito.QtdDebBloq,
        qntDebitoVencido: debito.QtdDebVenc,
        vetorDebitosSelecionados,
      });
    }
  }

  async function onClickPagamentoVencidos() {
    const { debitoResult } = anuidade;
    if (debitoResult) {
      const vetorDebitosSelecionados = getVetorDebitosSelecionados();
      buscarDadosCobranca({
        numeroFicha: debitoResult.Ficha,
        codigoTipoDebito: debitoResult.CodTipDeb,
        tipoSelecao: 'V',
        emitirSeparado: false,
        qntDebitoTotal: debitoResult.QtdDebTotal,
        valorTotal: debitoResult.ValDebTotal,
        qntDebitoBloqueado: debitoResult.QtdDebBloq,
        qntDebitoVencido: debitoResult.QtdDebVenc,
        vetorDebitosSelecionados,
      });
    }
  }

  async function onClickPagamentoDebitosSelecionados(emitirSeparado: boolean) {
    // $scope.activeStep.pagamentoTotal = false;
    // $scope.activeStep.pagamentoVencidos = false;
    const { debitoResult } = anuidade;
    if (debitoResult) {
      const vetorDebitosSelecionados = getVetorDebitosSelecionados();
      buscarDadosCobranca({
        numeroFicha: debitoResult.Ficha,
        codigoTipoDebito: debitoResult.CodTipDeb,
        tipoSelecao: 'S',
        emitirSeparado,
        qntDebitoTotal: debitoResult.QtdDebTotal,
        valorTotal: debitoResult.ValDebTotal,
        qntDebitoBloqueado: debitoResult.QtdDebBloq,
        qntDebitoVencido: debitoResult.QtdDebVenc,
        vetorDebitosSelecionados,
      });
    }
  }

  function changePagamento(form: PagamentoForm) {
    setPagamento({
      ...pagamento,
      pagamento: {
        ...form,
      },
    });
  }

  async function realizarDownloadBoleto(numeroCobranca: number) {
    try {
      const {
        pagamentoAnuidadeInscrito: { numeroFicha },
      } = anuidade;
      const { qntAvos } = pagamento;
      const result = await AnuidadeService.prepararBoleto(numeroFicha, {
        numeroCobranca,
        qntAvos,
      });
      if (result.Retorno !== 0) {
        tratarErroRetorno(result.Retorno, 'PB');
      } else {
        const resultAjustarDataBoleto = ajustarDataBoleto(result);
        await AnuidadeService.gerarBoleto(numeroFicha, resultAjustarDataBoleto);
        window.open(
          `${window.location.origin}${window.location.pathname}rest/anuidade/${numeroFicha}/download/${numeroCobranca}.pdf`,
        );
        toast.success('Seu boleto foi gerado com sucesso!');
      }
    } catch (e) {
      toast.error(
        'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
      );
    }
  }

  async function preparaBoletoDownloadZip(numerosCobranca: number[]) {
    try {
      const {
        pagamentoAnuidadeInscrito: { numeroFicha },
      } = anuidade;
      const { qntAvos } = pagamento;
      const boletos = await Promise.all(
        numerosCobranca.map(async (numeroCobranca) => {
          const result = await AnuidadeService.prepararBoleto(numeroFicha, {
            numeroCobranca,
            qntAvos,
          });
          if (result.Retorno !== 0) {
            tratarErroRetorno(result.Retorno, 'PB');
            throw Error();
          } else {
            const resultAjustarDataBoleto = ajustarDataBoleto(result);
            return resultAjustarDataBoleto;
          }
        }),
      );

      const { zipName } = await AnuidadeService.gerarBoletosZip(
        numeroFicha,
        boletos,
      );
      if (zipName) {
        window.open(
          `${window.location.origin}${window.location.pathname}rest/anuidade/${numeroFicha}/downloadzip/${zipName}`,
        );
        toast.success('Seus boletos foram gerados com sucesso!');
      }
    } catch (e) {
      toast.error(
        'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
      );
    }
  }

  async function goBoletoEnviarPorEmail() {
    setShowModalEnvioBoletoEmail(true);
  }

  async function goBoletoRealizarDownload() {
    setLoading(true);
    const { debitoResult } = anuidade;
    const {
      cobranca: { parcelas },
      emitirSeparado,
      pagamento: { parcelaSelecionada, tipoSelecao, formaPagamento },
    } = pagamento;
    const primeiraParcela = parcelas[0];

    const vetorDebitosSelecionados = getVetorDebitosSelecionados();

    if (debitoResult && parcelaSelecionada) {
      const gerarCobrancaRequest = {
        numeroFicha: debitoResult.Ficha,
        codigoTipoDebito: debitoResult.CodTipDeb,
        tipoSelecao,
        emitirSeparado,
        qntDebitoTotal: debitoResult.QtdDebTotal,
        valorTotal: debitoResult.ValDebTotal,
        qntDebitoBloqueado: debitoResult.QtdDebBloq,
        qntDebitoVencido: debitoResult.QtdDebVenc,
        vetorDebitosSelecionados,
        formaPagamento,
        valorAVista: primeiraParcela.valorPrimeiraParcela,
        quantidadeParcelas: parcelaSelecionada.qntParcelas,
        valorPrimeiraParcela: parcelaSelecionada.valorPrimeiraParcela,
        valorOutrasParcelas: parcelaSelecionada.valorOutrasParcelas,
        comoTratarUniao: debitoResult.ComoTratarUniao,
        existeCertidaoDeb: debitoResult.ExisteCertidaoDeb,
        codDistribuicao: debitoResult.CodDistribuicao,
      } as GerarCobrancaDTO;
      const result = await AnuidadeService.gerarCobranca(gerarCobrancaRequest);
      if (result.Retorno !== 0) {
        tratarErroRetorno(result.Retorno, 'GC');
      } else {
        const numerosCobranca = result.DadosCobrancas.VetorCob;
        if (numerosCobranca.length === 1) {
          const nc = numerosCobranca[0].NroCobranca;
          await realizarDownloadBoleto(nc);
        } else {
          await preparaBoletoDownloadZip(
            numerosCobranca.map((nc) => nc.NroCobranca),
          );
        }
      }
    }
    setLoading(false);
  }

  async function goCartaoRealizarPagamento() {
    setLoading(true);
    const { debitoResult } = anuidade;
    const {
      cobranca: { parcelas },
      pagamento: { parcelaSelecionada, tipoSelecao, formaPagamento },
    } = pagamento;
    const primeiraParcela = parcelas[0];

    const vetorDebitosSelecionados = getVetorDebitosSelecionados();

    if (debitoResult && parcelaSelecionada) {
      const gerarCobrancaRequest = {
        numeroFicha: debitoResult.Ficha,
        codigoTipoDebito: debitoResult.CodTipDeb,
        tipoSelecao,
        emitirSeparado: false,
        qntDebitoTotal: debitoResult.QtdDebTotal,
        valorTotal: debitoResult.ValDebTotal,
        qntDebitoBloqueado: debitoResult.QtdDebBloq,
        qntDebitoVencido: debitoResult.QtdDebVenc,
        vetorDebitosSelecionados,
        formaPagamento,
        valorAVista: primeiraParcela.valorPrimeiraParcela,
        quantidadeParcelas: parcelaSelecionada.qntParcelas,
        valorPrimeiraParcela: parcelaSelecionada.valorPrimeiraParcela,
        valorOutrasParcelas: parcelaSelecionada.valorOutrasParcelas,
        comoTratarUniao: debitoResult.ComoTratarUniao,
        existeCertidaoDeb: debitoResult.ExisteCertidaoDeb,
        codDistribuicao: debitoResult.CodDistribuicao,
      } as GerarCobrancaDTO;
      const result = await AnuidadeService.gerarCobranca(gerarCobrancaRequest);
      if (result.Retorno !== 0) {
        tratarErroRetorno(result.Retorno, 'GC');
      } else {
        const numerosCobranca = result.DadosCobrancas.VetorCob;
        const numeroCobranca = numerosCobranca[0].NroCobranca;
        const resultPC = await AnuidadeService.prepararCartao(
          debitoResult.Ficha,
          numeroCobranca,
        );
        setModalPagamentoCartao({
          show: true,
          urlCobrancaCartao: resultPC.urlCobrancaCartao,
        });
      }
    }
    setLoading(false);
  }

  function handleCloseModalPagamentoCartao() {
    setModalPagamentoCartao({
      show: false,
      urlCobrancaCartao: '',
    });
    history.replace('/');
  }

  async function handleSendBoletoEmail(email: string) {
    setLoading(true);
    try {
      const { debitoResult } = anuidade;
      const {
        cobranca: { parcelas },
        emitirSeparado,
        pagamento: { parcelaSelecionada, tipoSelecao, formaPagamento },
      } = pagamento;
      const primeiraParcela = parcelas[0];

      const vetorDebitosSelecionados = getVetorDebitosSelecionados();

      if (debitoResult && parcelaSelecionada) {
        const gerarCobrancaRequest = {
          numeroFicha: debitoResult.Ficha,
          codigoTipoDebito: debitoResult.CodTipDeb,
          tipoSelecao,
          emitirSeparado,
          qntDebitoTotal: debitoResult.QtdDebTotal,
          valorTotal: debitoResult.ValDebTotal,
          qntDebitoBloqueado: debitoResult.QtdDebBloq,
          qntDebitoVencido: debitoResult.QtdDebVenc,
          vetorDebitosSelecionados,
          formaPagamento,
          valorAVista: primeiraParcela.valorPrimeiraParcela,
          quantidadeParcelas: parcelaSelecionada.qntParcelas,
          valorPrimeiraParcela: parcelaSelecionada.valorPrimeiraParcela,
          valorOutrasParcelas: parcelaSelecionada.valorOutrasParcelas,
          comoTratarUniao: debitoResult.ComoTratarUniao,
          existeCertidaoDeb: debitoResult.ExisteCertidaoDeb,
          codDistribuicao: debitoResult.CodDistribuicao,
        } as GerarCobrancaDTO;
        const result = await AnuidadeService.gerarCobranca(
          gerarCobrancaRequest,
        );
        if (result.Retorno !== 0) {
          tratarErroRetorno(result.Retorno, 'GC');
        } else {
          const numerosCobranca = result.DadosCobrancas.VetorCob;
          const {
            pagamentoAnuidadeInscrito: { numeroFicha },
          } = anuidade;
          const { qntAvos } = pagamento;
          const boletos = await Promise.all(
            numerosCobranca.map(async ({ NroCobranca: numeroCobranca }) => {
              const resultPreparaBoleto = await AnuidadeService.prepararBoleto(
                numeroFicha,
                {
                  numeroCobranca,
                  qntAvos,
                },
              );
              if (resultPreparaBoleto.Retorno !== 0) {
                tratarErroRetorno(resultPreparaBoleto.Retorno, 'PB');
                throw Error();
              } else {
                const resultAjustarDataBoleto = ajustarDataBoleto(resultPreparaBoleto);
                return resultAjustarDataBoleto;
              }
            }),
          );

          await AnuidadeService.enviarBoletosEmail(numeroFicha, email, boletos);
          toast.success('E-mail enviado com sucesso!');
          setShowModalEnvioBoletoEmail(false);
        }
      }
    } catch (e) {
      toast.error(
        'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
      );
    }
    setLoading(false);
  }

  async function validarDebito() {
    setLoading(true);
    try {
      const {
        pagamentoAnuidadeInscrito: { numeroFicha },
        tipoDebito: { CodigoTipo },
        pesquisarComoTratarUniao,
      } = anuidade;
      const carregaDebito = await AnuidadeService.carregaDebito(
        numeroFicha,
        CodigoTipo,
        pesquisarComoTratarUniao,
      );
      if (carregaDebito.Retorno === 0) {
        const selecao: SelecaoDebitosModeProps = {
          showBtnPagamentoTotal: carregaDebito.PodeTotal === 'S',
          showBtnPagamentoVencidos: carregaDebito.PodeVencidos === 'S',
          showBtnSelecionarDebitos: carregaDebito.PodeSelecionar === 'S',
          showDebitos: false,
          selectDebitosEnabled: false,
          debitos: [],
        };

        setAnuidade({
          ...anuidade,
          debitoResult: carregaDebito,
        });

        const debitos = makeDebitos(carregaDebito.Dados.Vetor, 'RegDebito');
        selecao.showDebitos = true;
        selecao.debitos = debitos;

        if (
          selecao.showBtnPagamentoTotal
          && !selecao.showBtnPagamentoVencidos
          && !selecao.showBtnSelecionarDebitos
        ) {
          await onClickPagamentoTotal(carregaDebito, debitos);
        }

        if (selecao.showBtnSelecionarDebitos) {
          selecao.selectDebitosEnabled = true;
        }
        setSelecaoDebitosMode(selecao);
      } else {
        tratarErroRetorno(carregaDebito.Retorno, 'VTCD');
      }
    } catch (e) {
      toast.error(
        'Houve um problema na comunicação com o serviço. Tente novamente mais tarde!',
      );
    }
    setLoading(false);
  }

  useEffect(() => {
    // const values = queryString.parse(search);
    // if (values.anuidade) {
    //   const anuidadeParams = parseFloat(`${values.anuidade}`);
    // let anuidadeParams = parseFloat(`${values.anuidade}`);
    // if (anuidadeParams !== ANUIDADE_CORRENTE) {
    //   anuidadeParams = ANUIDADE_CORRENTE;
    //   setShowMensagemOutrasAnuidadesAreaRestrita(true);
    // }
    //   setAnoAnuidade(anuidadeParams);
    //   document.title = `OABRJ | Anuidade de ${values.anuidade}`;
    // } else {
    document.title = `OABRJ | Anuidade de ${ANUIDADE_CORRENTE}`;
    // }
  }, []);

  return (
    <AnuidadeContext.Provider
      value={{
        showMensagemOutrasAnuidadesAreaRestrita,
        anoAnuidade,
        tipoPagamentoRecorrente,
        anuidade,
        mensagemAlerta,
        selecaoDebitosMode,
        pagamento,
        validarAnuidade,
        validarDebito,
        changeSelectedDebito,
        onClickPagamentoTotal,
        onClickPagamentoVencidos,
        onClickPagamentoDebitosSelecionados,
        changePagamento,
        goBoletoEnviarPorEmail,
        goBoletoRealizarDownload,
        goCartaoRealizarPagamento,
        pagamentosRealizados,
      }}
    >
      {loading && <Loading />}
      <ModalPagamentoCartao
        show={modalPagamentoCartao.show}
        urlCobranca={modalPagamentoCartao.urlCobrancaCartao}
        onClose={handleCloseModalPagamentoCartao}
      />
      <ModalEnviarPorEmail
        show={showModalEnvioBoletoEmail}
        onClose={() => {
          setShowModalEnvioBoletoEmail(false);
        }}
        onSend={handleSendBoletoEmail}
      />
      {children}
    </AnuidadeContext.Provider>
  );
}

function useAnuidade(): AnuidadeContextData {
  const context = useContext(AnuidadeContext);
  return context;
}

export { AnuidadeProvider, useAnuidade };
